import { render, staticRenderFns } from "./news_details-app.vue?vue&type=template&id=aec9de3e&scoped=true"
import script from "./news_details-app.vue?vue&type=script&lang=js"
export * from "./news_details-app.vue?vue&type=script&lang=js"
import style0 from "./news_details-app.vue?vue&type=style&index=0&id=aec9de3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec9de3e",
  null
  
)

export default component.exports